let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("ldGmJ")]).then(() => parcelRequire('6L7mA'));